import { useTheme } from '@karnov/kui-react'
import { motion } from 'motion/react'

import { CarouselConfig } from './types'

import type { FC } from 'react'

type Props = {
  carouselConfig: CarouselConfig
  currentScreenIndex: number
  onDotClick: (index: number) => void
}

export const DotNavigation: FC<Props> = ({
  carouselConfig,
  currentScreenIndex,
  onDotClick,
}) => {
  const { isDarkMode } = useTheme()

  const initialBackground = isDarkMode ? '#434340' : '#ECECEC'
  const activeBackground = isDarkMode ? '#ECECEC' : '#2F2F2B'

  return (
    <div className="flex justify-center gap-x-4">
      {carouselConfig.screens.map((screen, index) => (
        <motion.button
          animate={{
            background:
              index === currentScreenIndex
                ? activeBackground
                : initialBackground,
          }}
          className="flex size-2 rounded-full bg-dark"
          id={index.toString()}
          initial={{
            background: initialBackground,
          }}
          key={screen}
          onClick={() => onDotClick(index)}
          transition={{ duration: 0.3, ease: 'easeInOut' }}
        />
      ))}
    </div>
  )
}
